import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genStepsVerticalStyle = function genStepsVerticalStyle(token) {
  var componentCls = token.componentCls,
    iconSizeSM = token.iconSizeSM,
    iconSize = token.iconSize;
  return _defineProperty({}, "&".concat(componentCls, "-vertical"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'column'
  }, "> ".concat(componentCls, "-item"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'block',
    flex: '1 0 auto',
    paddingInlineStart: 0,
    overflow: 'visible'
  }, "".concat(componentCls, "-item-icon"), {
    float: 'left',
    marginInlineEnd: token.margin
  }), "".concat(componentCls, "-item-content"), {
    display: 'block',
    minHeight: token.calc(token.controlHeight).mul(1.5).equal(),
    overflow: 'hidden'
  }), "".concat(componentCls, "-item-title"), {
    lineHeight: "".concat(unit(iconSize))
  }), "".concat(componentCls, "-item-description"), {
    paddingBottom: token.paddingSM
  })), "> ".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    position: 'absolute',
    top: 0,
    insetInlineStart: token.calc(iconSize).div(2).sub(token.lineWidth).equal(),
    width: token.lineWidth,
    height: '100%',
    padding: "".concat(unit(token.calc(token.marginXXS).mul(1.5).add(iconSize).equal()), " 0 ").concat(unit(token.calc(token.marginXXS).mul(1.5).equal())),
    '&::after': {
      width: token.lineWidth,
      height: '100%'
    }
  }), "> ".concat(componentCls, "-item:not(:last-child) > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    display: 'block'
  }), " > ".concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-content > ").concat(componentCls, "-item-title"), {
    '&::after': {
      display: 'none'
    }
  }), "&".concat(componentCls, "-small ").concat(componentCls, "-item-container"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-item-tail"), {
    position: 'absolute',
    top: 0,
    insetInlineStart: token.calc(iconSizeSM).div(2).sub(token.lineWidth).equal(),
    padding: "".concat(unit(token.calc(token.marginXXS).mul(1.5).add(iconSizeSM).equal()), " 0 ").concat(unit(token.calc(token.marginXXS).mul(1.5).equal()))
  }), "".concat(componentCls, "-item-title"), {
    lineHeight: "".concat(unit(iconSizeSM))
  })));
};
export default genStepsVerticalStyle;